<template>
  <div>
    <LoadingScreen v-if="!renderPresentationDetail" />
    <PresentationEditor v-if="currentUser.id" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

// components
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'
import PresentationEditor from '@/components-v2/presentation-editor/PresentationEditor.vue'

export default {
  components: {
    LoadingScreen,
    PresentationEditor,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      renderPresentationDetail: (state) => state.renderPresentationDetail,
    }),
  },
  created() {
    this.$store.state.renderPresentationDetail = false
  },
  destroyed() {
    this.$store.state.renderPresentationDetail = false
  },
}
</script>

<style lang="scss" scoped>
</style>
